import { render, staticRenderFns } from "./FTMTokenValue.vue?vue&type=template&id=0287da4e&"
import script from "./FTMTokenValue.vue?vue&type=script&lang=js&"
export * from "./FTMTokenValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports